/* Shared Shopify commerce. Prices and selling plans come from Liquid, never demo discounts. */
(function () {
  'use strict';
  var pending = new WeakMap();
  var queue = Promise.resolve();
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function route(name) { return (window.routes && window.routes[name + '_url']) || root() + name.replace(/_/g, '/'); }
  function money(cents) {
    var config = window.ZPTheme || {};
    return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', {
      style: 'currency', currency: config.currency || 'USD'
    }).format(Number(cents || 0) / 100);
  }
  function feedback(button, message) {
    var parent = button && (button.closest('form, [data-pp-card], .pp-bld-tray, .pp-stack-detail, .pp-pr-summary') || button.parentElement);
    parent = parent || document.getElementById('MainContent') || document.body;
    var el = parent.querySelector('[data-commerce-error]');
    if (!el) { el = document.createElement('p'); el.setAttribute('data-commerce-error', ''); el.setAttribute('role', 'alert'); parent.appendChild(el); }
    el.textContent = message || ''; el.hidden = !message;
  }
  function addItems(items, button) {
    if (button && pending.has(button)) return pending.get(button);
    var originalDisabled = button && button.disabled;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    feedback(button, '');
    var active = document.activeElement;
    var run = queue.then(async function () {
      try {
        if (!Array.isArray(items) || !items.length) throw new Error('Choose at least one available product.');
        var normalized = items.map(function (item) {
          var id = Number(item.id), quantity = Number(item.quantity);
          if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Choose a valid product and quantity.');
          var value = { id: id, quantity: quantity };
          if (item.selling_plan) value.selling_plan = Number(item.selling_plan);
          if (item.properties) value.properties = item.properties;
          return value;
        });
        var drawer = document.querySelector('cart-drawer');
        var body = { items: normalized };
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
          if (drawer.setActiveElement) drawer.setActiveElement(active);
        }
        var response = await fetch(route('cart_add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        var state;
        try { state = await response.json(); } catch (parseError) { throw new Error('Shopify could not confirm this cart update. Check your cart before trying again.'); }
        if (!response.ok || state.status) throw new Error(state.description || state.message || 'Unable to add this product. Please try again.');
        document.dispatchEvent(new CustomEvent('zp:cart:added', { detail: state }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'brand-commerce', cartData: state });
        var sectionsReady = drawer && body.sections && state.sections && body.sections.every(function (id) { return typeof state.sections[id] === 'string'; });
        if (sectionsReady && drawer.renderContents) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(state); }
          catch (renderError) { window.location.assign(route('cart')); }
        } else { window.location.assign(route('cart')); }
        return { ok: true, state: state };
      } catch (error) {
        feedback(button, error.message || 'Unable to add products. Please try again.');
        return { ok: false, error: error.message };
      } finally {
        if (button) { button.disabled = originalDisabled; button.removeAttribute('aria-busy'); pending.delete(button); }
      }
    });
    queue = run.catch(function () {});
    if (button) pending.set(button, run);
    return run;
  }
  window.zpMoney = money;
  window.zpCartRoute = route;
  window.zpCommerceError = feedback;
  window.zpAddItems = addItems;
  window.zpAddToCart = function (id, quantity, plan, button) {
    var item = { id: id, quantity: quantity == null ? 1 : quantity };
    if (plan) item.selling_plan = plan;
    return addItems([item], button);
  };
})();

/* The cart drawer's "Add one to qualify" upsell.

   Its markup ships as <button type="submit"> inside <product-form>, but by the
   time it reaches the page the type has been rewritten to "button", so no
   submit event ever fires and <product-form> never sees one. The result was a
   button that did literally nothing: no request, no feedback, cart unchanged.

   Binding it to the theme's own add-to-cart avoids depending on whatever does
   the rewriting, and reuses the path the rest of the site already uses —
   zpAddToCart handles the disabled/aria-busy state, re-renders the drawer and
   reopens it. Delegated, because the drawer replaces its markup on every cart
   update, which would drop a directly-bound listener. */
document.addEventListener('click', function (event) {
  var target = event.target;
  if (!target || !target.closest) return;
  var button = target.closest('.cart-drawer__upsell-add');
  if (!button) return;
  event.preventDefault();
  /* Stop the click here. Zipify OneClickUpsell listens for add-to-cart
     interactions and used to turn this one into a checkout redirect; nothing
     else needs to see it. */
  event.stopImmediatePropagation();
  var form = button.closest('form');
  var idField = form && form.querySelector('input[name="id"]');
  var variantId = button.getAttribute('data-variant-id') || (idField && idField.value);
  if (!variantId || typeof window.zpAddToCart !== 'function') return;
  window.zpAddToCart(variantId, 1, null, button);
}, true);
